export default {
      id: "ic_tv_stack_circle-usage",
      viewBox: "0 0 13 13",
      url: "/" + "images/icons.3.109.2.svg#ic_tv_stack_circle-usage",
      toString: function () {
        return this.url;
      }
    }